import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import supportDeskService from '../../services/supportDeskService';

const initialState = {
  faqs: [],
  isLoading: false,
  error: null,
};

export const fetchFAQs = createAsyncThunk(
  'faqs/fetchFAQs',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await supportDeskService.getFAQs(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch FAQs');
    }
  }
);

const faqSlice = createSlice({
  name: 'faqs',
  initialState,
  reducers: {
    clearFAQError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFAQs.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchFAQs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.faqs = action.payload.results || action.payload;
        state.error = null;
      })
      .addCase(fetchFAQs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch FAQs';
      });
  },
});

export const { clearFAQError } = faqSlice.actions;
export default faqSlice.reducer;
